<template>
  <div>
    <md-dialog-prompt
      :md-active.sync="show_reset"
      v-model="email"
      md-title="איפוס סיסמה"
      md-input-placeholder="הזן את המייל שלך"
      @md-confirm="onConfirmResetPass()"
      md-confirm-text="שלח" 
      md-cancel-text="בטל"/>
    <h2>נא לבחור פרופיל</h2>
    <div class="wrapper centered">
       <ul>
         <div v-for="profile in user_data.profiles" :key="profile.id" class="item">
     
         <li class="profile_link"  @click="change_profile(profile.id); enter_profile(profile.id)">
           <div class="pic"></div><span v-text="(profile.name != '' ? profile.name : 'הפרופיל שלך')"></span>
             </li>
         
           <a @click="profile_id=profile.id;show_reset = true" style="text-decoration:under-line !important;display:block">שכחתי סיסמה</a>
         </div>    
       </ul>
      </div>


  </div>
</template>
<style lang="scss" scoped>
.wrapper ul{display: flex;text-align: center;}
.profile_link{
       &{flex: 1;display: inline-block;margin: 0 20px;}
       span{display: block;margin: 20px 0;font-size: 20px;}
  }
  h2{text-align: center;padding-top: 100px;font-size: 35px;margin-bottom: 50px;}
  .pic{border-radius: 100%;height: 213px;width: 213px;margin-bottom: 10px;margin: 0 auto;border: 1px dashed #fff;background-color: #373737;}
  .item:nth-child(2n+1){clear: both;}
@media only screen and (max-width: 600px) {
    .item{display: block;width: 50%;}
    .pic{height: 110px;width: 110px;}
  }
</style>
<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],

  props: ["user_data", "menu","profile"],
  
  data() {
    return {
      profile_id:'',
      email:'',
      show_reset: false,
      show_user_menu: false,
      user_token: localStorage.getItem('user_token')
    };
  },
  
  computed: {
  },
  methods:{

     onConfirmResetPass(){
      var self = this;
      this.api_call({ url: 'password_profile_reset', data:{ email: this.email, profile_id:this.profile_id} ,onComplete: function(data){
        self.status = data.data.data
     if(self.status)
        {
          alert('סיסמתך נשלחה למייל שהוזן');
       
        }
        else{
          alert("המייל לא נמצא במערכת")
        }
       
      }})
    },
    change_profile(id){

      var curr_profile = false;
      for (let i in this.user_data.profiles)
      {
        if (this.user_data.profiles[i].id == id) 
        {
          curr_profile = this.user_data.profiles[i];
          break;
        }
      }
      if (curr_profile)
      {
        if (curr_profile.password != '')
        {
       
          
     this.$prompt("נא להזין את סיסמת הפרופיל:", "", "", "question", { input: 'password' }).then(pass => {
        if (pass != curr_profile.password)
          {
             this.$alert('הסיסמה אינה נכונה, אנא נסה שנית');
            return;
          }
          else{
this.api_call({ url: 'change_profile', data: {id: id}, onComplete: function(data){
                      localStorage.setItem('user_token', data.data.data);
                      window.sessionStorage.setItem('profile_id', id);
                      document.location = window.location.href;

        }});
          }
      });
          
          
        }

        
         
      }
    },
      enter_profile(id){

      var curr_profile = false;
      for (let i in this.user_data.profiles)
      {
        if (this.user_data.profiles[i].id == id) 
        {
          curr_profile = this.user_data.profiles[i];
          break;
        }
      }
      if (curr_profile)
      {
        if (curr_profile.password == '')
        {

          this.api_call({ url: 'change_profile', data: {id: id}, onComplete: function(data){
                      localStorage.setItem('user_token', data.data.data);
                      window.sessionStorage.setItem('profile_id', id);
                      document.location = '/';

        }});
          }
    
          
          
        }

        
        
      
    },
    
    logout(){
      localStorage.removeItem('user_token');
      document.location = '/';

    },
    
    away: function() {
      this.show_user_menu = false;
    },
  },


}
</script>